import Fingering from "./Fingering";
import Measure from "./Measure";
import {SegmentModeEnum} from "./SegmentModeEnum";
import {HandsTypeEnum} from "./HandsTypeEnum";
import ISpeedSelectOption from "./ISpeedSelectOption";
import LessonPlayerSettings from "./LessonPlayerSettings";

/**
 * Segment
 */
export default class Segment {
  baseEmbedUrl: string; //Soundslice slug
  courseId?: string;
  //&#13; is carriage return.  &#10; is line feed.  Should be converted to <br/> before populating the field.  This is just a reminder that it comes from the api in this format.
  descriptionHtml: string; // e.g. Let's work on playing Middle C with our right hand. If you can't recall where Middle C ...  so you can easily find it.&#13;
  fingerings?: Fingering[]; // what keyboard keys should have coloring/numbering/etc.
  hands: HandsTypeEnum;
  hasUserCompletedTheSegment: boolean;
  hasVideo: boolean;
  id: string; // needed when adding practice records. e.g. 9447
  isFirstSegmentOfLesson: boolean;
  isLastSegmentOfLesson: boolean;
  isUserAccuracyScoreGreen: boolean;
  lessonDifficulty: number; //difficulty of the parent lesson is needed in order to grade performances.
  lessonId: string; //parent lesson's id
  measures: Measure[]; //measures/bars for the piece of music being played.
  mode: SegmentModeEnum; //not sure how this is used yet... e.g. ["practice"]
  name: string; // e.g. 1/7 RH Middle C
  lessonPlayerSettings: LessonPlayerSettings;
  recordingIndex: number; // e.g. 0 for sheetmusic only.  1 for sheetmusic + video || accompanying track. Sent to soundslice as part of get notes
  segmentIndex?: number;
  shouldHideSegmentDescription: boolean;
  soundsliceIframeUrl: string;
  speedOptions: ISpeedSelectOption[];
  tabDisplayText: string; // text on the left of the page that user can click to switch between segments. e.g. "1", "2", etc
  tempo: number; //we only support 1 tempo per segment, so data will be extracted from the measureMetadata, and set here.
  url: string; //used for links e.g. /lesson/{lessonId}/{segmentId}
  userAccuracyScore?: number;

  constructor({
    id,
    name,
    fingerings,
    mode,
    recordingIndex,
    descriptionHtml,
    url,
    soundsliceIframeUrl,
    tabDisplayText,
    measures,
    tempo,
    lessonPlayerSettings,
    baseEmbedUrl,
    hasVideo,
    lessonDifficulty,
    hands,
    lessonId,
    speedOptions,
    shouldHideSegmentDescription,
    hasUserCompletedTheSegment,
    userAccuracyScore,
    isUserAccuracyScoreGreen,
    courseId,
    segmentIndex,
    isFirstSegmentOfLesson,
    isLastSegmentOfLesson
  }: Segment) {
    Object.assign(this, {
      id,
      name,
      fingerings,
      recordingIndex,
      descriptionHtml,
      url,
      soundsliceIframeUrl,
      tabDisplayText,
      measures,
      tempo,
      lessonPlayerSettings: lessonPlayerSettings,
      baseEmbedUrl,
      hasVideo,
      lessonDifficulty,
      mode,
      hands,
      lessonId,
      speedOptions,
      shouldHideSegmentDescription,
      hasUserCompletedTheSegment,
      userAccuracyScore,
      isUserAccuracyScoreGreen,
      courseId,
      segmentIndex,
      isFirstSegmentOfLesson,
      isLastSegmentOfLesson
    });
  }
}